import { render, staticRenderFns } from "./HeaderAuth.vue?vue&type=template&id=5308f5c6&"
import script from "./HeaderAuth.vue?vue&type=script&lang=js&"
export * from "./HeaderAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports